import React, {useState} from 'react';
import {Table, Select} from 'antd';
import styled from 'styled-components';
import { AdvertiserCol } from '@app/pages/QBIT/Fund/atoms/LoanTable/AdvertiserCol.tsx';
import useGetCoinTier from '@app/hooks/trade/coinTier.ts';
import BigNumber from 'bignumber.js';
import { useTranslation } from 'react-i18next';

export const TierTable = () => {
  const {data, getCoinTiersByBase} = useGetCoinTier();
  const baseList:any = Array.from(new Set(data.map(item => item.base)));
  const {t} = useTranslation();
  const [symbol, setSymbol] = useState('BTC')



  const columns = [
    {
      dataIndex: "level",
      title: t("tier"),
      render: (value, data) => {
        return (
         <TierText>{value}</TierText>
        );
      },
    },
    {
      dataIndex: "",
      title: t("PositionBracket"),
      render: (value, data) => {
        return  <TierText>{`${BigNumber(data?.notional_min).toFormat()} ~ ${BigNumber(data?.notional_max).toFormat()}`}</TierText>;
      },
    },
    {
      dataIndex: "max_leverage",
      title: t("MaxLeverage"),
      render: (value, data) => {
        return (
          <TierText>{value + 'x'}</TierText>
        );
      },
    },
    {
      dataIndex: "mmr",
      title: t("MaintenanceMarginRate"),
      render: (value, data) => {
        return  <TierText>{BigNumber(value).multipliedBy(100).toFormat(2) + '%'}</TierText>;
      },
    },
    {
      dataIndex: "ma",
      title: t("MaintenanceAmount"),

      render: (value, data) => {
        return (
          <TierText>{BigNumber(value).toFormat()}</TierText>
        );
      },
    },
  ];


  return (
    <TierTableWrapper>
      <TierTableHeader>
        <Select  onChange={setSymbol} value={symbol} style={{ width: 200, height: 40, textAlign: 'right' }} prefix={<div style={{color: '#999a9f'}}>{t('symbol')}</div>}>
          {baseList?.map((base) => (
            <Select.Option value={base} key={base}>
              {base}
            </Select.Option>
          ))}
        </Select>
      </TierTableHeader>

      <Table
        dataSource={getCoinTiersByBase(symbol)}
        columns={columns}
        pagination={false}
      />

    </TierTableWrapper>
  )
}

const TierTableWrapper = styled.div`
    margin-bottom: 40px;
`;

const TierTableHeader = styled.div`
    margin-bottom: 20px;
`

const TierText = styled.div`
    text-align: left;
  font-size: 16px;
`